import React from "react"
import Layout from "../components/layout"
import { graphql } from "gatsby"
import { Box } from "rebass"
import { SizeMe } from "react-sizeme"

import Header from "../components/header"
import Hero from "../components/hero"
import BookPreview from "../components/book-preview"
import BookPreviewGrid from "../components/book-preview-grid"
import Snippet from "../components/snippet"
import Carousel from "../components/carousel"
import Links from "../components/links"
import Excerpt from "../components/excerpt"
import ArticleList from "../components/article-list"
import HeadingBar from "../components/heading-bar"
// import Giveaway from "../components/giveaway"
// import TourDates from "../components/tour-dates"
import Footer from "../components/footer"

const IndexPage = ({ data }) => (
  <Layout>
    <Header />
    <Hero />
    <Box as="section" id="book-cover">
      <BookPreview cover={data.coverImage.childImageSharp.fluid} />
      <BookPreviewGrid />
    </Box>
    <Box as="section" id="snippet">
      <Snippet />
    </Box>
    <Box as="section" id="quotes">
      <SizeMe monitorHeight>
        {size => (
          <Carousel size={size} quotes={data.site.siteMetadata.quotes} />
        )}
      </SizeMe>
    </Box>
    <Box as="section" id="preorder-top">
      <HeadingBar>On Sale Now</HeadingBar>
      <Links links={data.site.siteMetadata.preorderLinks} />
    </Box>
    <Box as="section" id="excerpt">
      <Excerpt />
    </Box>
    <Box as="section" id="articles">
      <HeadingBar>Essays</HeadingBar>
      <ArticleList articles={data.site.siteMetadata.articles} />
    </Box>
    <Box as="section" id="preorder-bottom">
      <HeadingBar>On Sale Now</HeadingBar>
      <Links links={data.site.siteMetadata.preorderLinks} />
    </Box>
    <Box as="footer">
      <Footer links={data.site.siteMetadata.socialLinks} />
    </Box>
  </Layout>
)

export const query = graphql`
  query {
    site {
      siteMetadata {
        socialLinks {
          label
          url
        }
        quotes {
          body
          citation
        }
        tourDates {
          date
          venue
        }
        articles {
          heading
          url
        }
        preorderLinks {
          retailer
          url
        }
      }
    }
    coverImage: file(relativePath: { eq: "cover.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 500) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`

export default IndexPage
